/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DMSExchangeTokenDto interface.
 */
export function instanceOfDMSExchangeTokenDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    return true;
}
export function DMSExchangeTokenDtoFromJSON(json) {
    return DMSExchangeTokenDtoFromJSONTyped(json, false);
}
export function DMSExchangeTokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
    };
}
export function DMSExchangeTokenDtoToJSON(json) {
    return DMSExchangeTokenDtoToJSONTyped(json, false);
}
export function DMSExchangeTokenDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
    };
}
